export enum FeedbackType {
  dislike = 0, // 不喜欢
  good = 1, // 赞
  complaint = 2, // 投诉
  cancel = 10000, // 取消
}

export enum TRegenerateJudge {
  better = "better",
  worse = "worse",
  same = "same",
  cancel = "cancel",
}

export type TSession = {
  title: string;
  create_time: string;
  session_id: string;
  channel?: string;
  status: ESessionStatus;
  chatModel: EChatModel;
};

export interface IUrlState {
  chatModel: string;
  sessionId: string;
  channel: string;
}

export enum EChatModel {
  chat = "chat",
  moe = "moe",
}

export enum AgreeType {
  userPrivacy = 1, //用户隐私
  infoCollect = 2, //信息收集
}

export enum ESessionStatus {
  work = "work",
  invalid = "invalid",
  history = "history",
}

export enum MessageErrorType {
  sensitiveWords = 18,
  model = 15,
  network = "net",
  sessionDeleted = 20,
  multiFile = 21,
  busy = 7, // 正在回答中
  fileParseParam = 1001, // 入参有误
  fileParseDb = 1002, // 数据库错误
  fileParseOss = 1003, // oss错误
  fileParseRedis = 1004, // redis错误
  fileParseParse = 1005, // 文件解析错误
  fileParseAuth = 1006, // 认证有误
  fileParseAuthService = 1007, // 认证服务连接有误
  fileParseFileId = 1008, // 文件id不存在
  fileParseLost = 1009, // 文件不存在
  fileParseLarge = 1010, // 文件过大
  fileParseContent = 1011, // 文件内容超限制
  moeModelError = 20101, // 模型错误
  assistantDisabled = 40101, // session被删除
  buddyDisabled = 40102, // buddy 不可用
}

export interface UploadedFile {
  file_id?: string;
  file_name: string;
  status: string;
  url: string;
}

export interface IFile {
  id: string;
  name: string;
  url: string;
}

export enum EChatStatus {
  init = "init",
  prepare = "prepare",
  fileParsing = "fileParsing",
  streaming = "streaming",
  streamData = "streamData",
  streamEnd = "streamEnd",
}

export interface IMessage {
  compare_rating: null | TRegenerateJudge;
  complete: number;
  // edit_msg: null;
  edit_time?: null;
  output: string;
  parent_id: string;
  recv_time?: string;
  send_msg: string;
  send_time?: string;
  sensitive_type?: null;
  turn_id: string;
  user_score: null;
  file_id: string | null;
  file_name: string | null;
  isRegenerated?: boolean;
}

export interface IDialogOptions {
  parent_id: string;
  msg: string;
  action: string;
  channel: string;
  session_id: string;
}

export enum EMoeSessionStatus {
  in_progress = "in_progress",
  completed = "completed",
  failed = "failed",
  idle = "idle",
}

export interface IMoeFile {
  name: string;
  url: string;
}

export interface IMoeFileDetail {
  file_id: string;
  file_name: string;
  status: string;
  url: string;
}

export interface IMoeHistory {
  files: Omit<IFile, "id">[];
  output: any;
  parent_id: string;
  recv_time: string;
  send_time: string;
  send_msg: string;
  turn_id: string;
  user_score: number;
  turn_status: "sucesss" | "failed";
}

export enum ERole {
  loading = 0,
  init = 1,
  ai = 2,
  user = 3,
}

// start stream moe
export enum EMoeToolStatus {
  // text2image:绘图中，coding：开始编码；going：正在执行；other: 正在思考；end: 本次流式输出结束
  text2image = "text2image",
  web_searcher = "web_searcher",
  coding = "coding",
  going = "going",
  other = "other",
  end = "end",
}

export enum EMoeToolType {
  files = "file",
  code = "code",
  text = "text",
  tool_calls = "tool_calls",
  status = "status",
  image = "image",
}

export interface IMoeText {
  value: string;
}
export interface IMoeTool {
  name: string;
}

export interface IMoeCode {
  value: string;
  result: {
    files: string[];
    output: string;
  };
}
export interface IMoeOutputMsg {
  code: IMoeCode;
  files: string[];
  text: IMoeText;
  status: "text2image" | "coding" | "going" | "other" | "end";
  tool_calls: IMoeTool[];
  type: EMoeToolType;
  isSse?: boolean;
}

export interface IMoeHistoryV2 {
  files: Omit<IFile, "id">[];
  output: any;
  parent_id: string;
  recv_time: string;
  send_time: string;
  send_msg: string;
  turn_id: string;
  user_score: number;
  complete?: boolean;
  turn_status: "success" | "error";
}

export interface IMoeMessageV2 {
  role: ERole;
  files?: Omit<IFile, "id">[]; // 用户上传文件
  message: undefined | string | IMoeOutputMsg[];
  turn_id: string;
  id: string;
  user_score?: number;
  errorType?: MessageErrorType;
  parent_id: string;
  isBlock?: boolean;
  turn_status?: string;
}

// 流式moe 历史
export interface IMoeRecordV2 {
  files: Omit<IFile, "id">[];
  output: IMoeOutputMsg[];
  parent_id: string;
  recv_time: string;
  send_msg: string;
  send_time: string;
  turn_id: string;
  turn_status: string;
  user_score?: FeedbackType;
}

export interface IMoeRecordListV2 {
  session_history: IMoeHistory[];
  status: ESessionStatus;
}

// end stream moe

export interface IMoeMessage {
  role: ERole;
  files?: Omit<IFile, "id">[];
  message: any;
  turn_id: string;
  id: string;
  user_score?: number;
  errorType?: MessageErrorType;
  parent_id: string;
}

export interface IMoeRecord {
  session_history: IMoeHistory[];
  status: {
    session_id: string;
    session_status: EMoeSessionStatus;
  };
}

export interface ISession {
  session_history: IHistory[];
  session_id: string;
  session_status: ESessionStatus;
}

export interface IWebSearch {
  icon: string;
  index: number;
  title: string;
  url: string;
  url_source: string;
}
export interface IHistory {
  complete: boolean;
  output: string;
  parent_id: string;
  recv_time: string;
  send_msg: string;
  send_time: string;
  turn_id: string;
  web_search: IWebSearch[];
}

// 暂时看不到接口文档,这里要和接口统一
export enum EFuntionCall {
  vqa_agent = "vqa_agent",
  data_analysis = "data_analysis", // code
  web_search = "web_search",
  text2image = "text2image",
  thinking = "thinking",
  running = "running",
}

/**
 * old chat Types
 */

export type TUser = {
  user_id: string;
  user_token: string;
  user_mobile: string;
};

export type TAnswer = {
  output: string;
  turn_id: string;
  session_id: string;
  edit_msg?: string;
  user_score?: number;
  poem_format?: boolean;
};

export type TMessage = {
  role?: ERole;
  message?: string;
  send_msg?: string;
  turn_id: string;
  id: string;
  edit_msg?: string;
  user_score?: number;
  poem_format?: boolean;
  status?: EChatStatus;
  errorType?: MessageErrorType;
  isRegenerated?: boolean;
  compare_rating?: string;
  parent_id?: string;
  isBlock?: boolean;
};

export type TTreeRecord = {
  turn_id: string;
  send_time: string;
  send_msg: string;
  recv_time: string;
  output: string;
  edit_msg: string;
  edit_time: string;
  user_score: number;
  poem_format: boolean;
  parent_id: string;
  compare_rating: string;
  complete: boolean;
  children: TTreeRecord[];
};

export type TNewSession = {
  channel: string;
  session_id: string;
};

export type TTips = {
  scenes: string;
  tips: string[];
};

export type TTabs = {
  channel: string;
  content: TTips[];
};

export type TUserScore = null | 0 | 1;

export type TSample = {
  scenes: string;
  tip: string;
};

export enum EDemoRole {
  assistant = "assistant",
  tool = "tool",
  user = "user",
}

export enum EDemoFileType {
  file_url = "file_url",
  image_url = "image_url",
}

export interface IDemoContent {
  role: EDemoRole;
  content:
    | {
        type: EDemoFileType;
        file_url?: {
          parsed_file_id: string;
          name: string;
        };
        image_url?: {
          url: string;
          name: string;
        };
      }[]
    | string;
}

export interface IDemoInputMessage {
  text: string;
  fileList: UploadedFile[];
}

export interface IDemoMessage {
  role: ERole;
  id: string;
  turn_id: string;
  message: IDemoInputMessage | string;
}

export interface IDemoSession {
  session_id: string;
  title: string;
  session_history?: IDemoMessage[];
}

export interface IDemoOutputMsg {
  text: string;
  isSse?: boolean;
}
